import React from 'react'
import minus from '../assets/images/minus-item.png'
import plus from '../assets/images/plus-item.png'
import { useState } from 'react'
import './newTrip.css'
import { useSelector } from 'react-redux'
import { fetchCurrentTripForm } from '../redux/features/tripFormSlice'

export default function Counter({ adultDefault, handleAdultsCount, days }) {
  const tripFormData = useSelector(fetchCurrentTripForm)

  const [amount, setAmount] = useState(0)
  const [adultsAmount, setAdultsAmount] = useState(2)
  const [adultsChange, setadultsChange] = useState(false)
  const [daysCount, setDaysCount] = useState(tripFormData.days)

  const handleIncrease = () => {
    if (adultDefault) {
      setAdultsAmount((prevadultsAmount) => (prevadultsAmount += 1))
      setadultsChange(true)
    } else if (days) {
      setDaysCount((prevdaysCount) => (prevdaysCount += 1))
    } else {
      setAmount(amount + 1)
    }
  }

  const handleDecrease = () => {
    if (adultDefault && adultsAmount > 0) {
      setAdultsAmount((prevadultsAmount) => (prevadultsAmount -= 1))
      setadultsChange(true)
    } else if (days) {
      setDaysCount((prevdaysCount) => (prevdaysCount -= 1))
    } else if (amount > 0) {
      setAmount(amount - 1)
    }
  }

  if (adultsChange) {
    handleAdultsCount(adultsAmount)
    setadultsChange(false)
  }

  return (
    <div className="counter">
      <div className="symbol" onClick={handleDecrease}>
        <img src={minus} alt="minus" />
      </div>
      <div className="amount">
        <p>{days ? daysCount : adultDefault ? adultsAmount : amount}</p>
      </div>
      <div className="symbol" onClick={handleIncrease}>
        <img src={plus} alt="plus" />
      </div>
    </div>
  )
}
